module.exports = __webpack_public_path__ + "img/30YearsGroupPhoto.e4b4687b.jpg";